import { SPECIAL_SPACES, HTML_ENTITY_SPACE_PATTERNS } from '../constants/TextSanitizationConstants'

/**
 * Removes special Unicode spaces and HTML entity spaces from text
 * Used for sanitizing user input that may contain copy-pasted content with HTML entities
 *
 * @param {string} text - The text to sanitize
 * @returns {string} - The sanitized text with special spaces and HTML entities removed
 */
export const removeSpecialSpacesAndEntities = text => {
  if (!text || typeof text !== 'string') {
    return text || ''
  }

  let sanitizedText = text

  // Remove Unicode special spaces
  const specialSpacesRegex = new RegExp(`[${SPECIAL_SPACES}]`, 'g')
  sanitizedText = sanitizedText.replace(specialSpacesRegex, '')

  // Remove HTML entity spaces
  HTML_ENTITY_SPACE_PATTERNS.forEach(pattern => {
    sanitizedText = sanitizedText.replace(pattern, '')
  })

  return sanitizedText
}
